import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React from 'react';
import { CardActionIconButtonVariant, CardActionsView } from './cardActions';
import { ActionsBarWrapper } from './actionsBarWrapper';
export var ActionsBar = /*#__PURE__*/function (_React$Component) {
  function ActionsBar() {
    _classCallCheck(this, ActionsBar);
    return _callSuper(this, ActionsBar, arguments);
  }
  _inherits(ActionsBar, _React$Component);
  return _createClass(ActionsBar, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isFixed = _this$props.isFixed,
        filename = _this$props.filename,
        actions = _this$props.actions;
      if (actions.length === 0) {
        return null;
      }
      return /*#__PURE__*/React.createElement(ActionsBarWrapper, {
        isFixed: isFixed
      }, /*#__PURE__*/React.createElement(CardActionsView, {
        filename: filename,
        actions: actions,
        variant: CardActionIconButtonVariant.filled
      }));
    }
  }]);
}(React.Component);